<!-- <router-outlet></router-outlet> -->
<div id="all" *ngIf="true || datas" (click)="onClick()" [class]="'fullHD roboto step-'+current">
  <div id="splash" class="page roboto fullHD" *ngIf="current == 'splash'" (click)="onSplashClick()" [style.background]="bgImage">
    <div class="group">
      <div class="title suburban"><span [innerHTML]="datas.title" [style.backgroundColor]="espace.color">...</span></div>
      <div class="baseline">
        <span [innerHTML]="datas.baseline">...</span>
        <span class="picto" *ngIf="espace" [style.backgroundColor]="espace.color">
          <svg width="1em" height="1em" viewBox="0 0 27 33" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path class="st0" d="M12.39,10.74c0-2.09,0.05-4.5-0.03-6.9c-0.03-0.64-0.29-1.52-0.76-1.84c-0.56-0.38-1.65-0.59-2.15-0.3
              C8.83,2.07,8.19,3.03,8.17,3.76c-0.12,4.47-0.05,8.93-0.08,13.4c0,0.46-0.34,0.9-0.52,1.36c-0.37-0.27-0.81-0.5-1.05-0.85
              c-0.55-0.81-0.91-1.74-1.48-2.53c-0.64-0.91-1.6-1.19-2.59-0.66c-1.01,0.55-0.84,1.42-0.41,2.32c2.12,4.51,4.19,9.05,6.36,13.54
              c0.24,0.5,1.04,1.05,1.57,1.05c3.98,0.09,7.94,0.06,11.92,0.05c2-0.02,3.35-1.37,3.37-3.37c0.03-3.8,0.05-7.59-0.03-11.39
              c-0.02-0.67-0.43-1.46-0.91-1.94c-0.37-0.35-1.19-0.47-1.72-0.35c-0.56,0.14-1.05,0.67-1.59,1.05c0.02-1.27,0.06-2.56-1.42-3.16
              c-1.22-0.49-2.01,0.18-2.91,1.16c0.09-1.49,0.06-2.93-1.42-3.26C14.39,10,13.37,10.53,12.39,10.74z"/>
              <path class="st0" d="M12.39,10.74c0.98-0.21,2-0.75,2.87-0.56c1.48,0.32,1.51,1.77,1.42,3.26c0.9-0.96,1.69-1.65,2.91-1.16
              c1.48,0.59,1.42,1.89,1.42,3.16c0.55-0.38,1.02-0.93,1.59-1.05c0.53-0.12,1.36-0.02,1.72,0.35c0.49,0.47,0.9,1.27,0.91,1.94
              c0.09,3.8,0.06,7.59,0.03,11.39c-0.02,2.01-1.37,3.35-3.37,3.37c-3.98,0.03-7.96,0.05-11.92-0.05c-0.55-0.02-1.33-0.55-1.57-1.05
              c-2.16-4.48-4.24-9.02-6.36-13.54c-0.43-0.91-0.59-1.78,0.41-2.32c0.99-0.53,1.95-0.26,2.59,0.66c0.56,0.79,0.93,1.72,1.48,2.53
              c0.24,0.37,0.7,0.58,1.05,0.85c0.18-0.46,0.52-0.9,0.52-1.36c0.05-4.47-0.03-8.93,0.08-13.4c0.02-0.73,0.66-1.69,1.28-2.07
              c0.5-0.3,1.59-0.08,2.15,0.3c0.47,0.32,0.75,1.2,0.76,1.84C12.44,6.25,12.39,8.66,12.39,10.74z"/>
            </g>
          </svg>
        </span>
      </div>
    </div>
  </div>

  <div id="game" [class.show]="current == 'game'">
    <div class="bg"></div>
    <div class="overlays" *ngIf="current == 'game'">
      <div class="network">
        <svg #network version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        	 viewBox="0 0 1920 1080" style="enable-background:new 0 0 1920 1080;" xml:space="preserve">
        <style type="text/css">
        	.st0{fill:#E2DDDB;}
        	.st1{fill:#FFFFFF;stroke-miterlimit:10;}
        	.st2{fill:#FFFFFF;}
        	.st3{fill:none;stroke:#333333;stroke-miterlimit:10;}
        	.st4{fill:#333333;}
        	.st5{fill:#FFFFFF;stroke:#333333;stroke-width:11;stroke-miterlimit:10;}
        	.st6{fill:#EF4023;stroke:#333333;stroke-miterlimit:10;}
        	.st7{fill:#F2594E;stroke:#333333;stroke-miterlimit:10;}
        	.st8{fill:#F2BDB6;stroke:#333333;stroke-miterlimit:10;}
        	.st9{fill:#F28577;stroke:#333333;stroke-miterlimit:10;}
        	.st10{fill:#3F3F3F;}
        	.st11{fill:#333333;stroke:#333333;stroke-miterlimit:10;}
        	.st12{fill:#E2DDDB;stroke:#333333;stroke-miterlimit:10;}
        	.st13{fill:#EF4023;}
        	.st14{opacity:0.7;fill:#333333;}
        	.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#EF4023;}
        	.st16{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        </style>
        <g class="lines">
        	<g>
        		<g>
        			<g>
        				<line class="st1" x1="630.88" y1="332.67" x2="959.88" y2="245"/>
        				<line class="st1" x1="959.88" y1="304" x2="630.88" y2="332.67"/>
        				<line class="st1" x1="959.88" y1="363" x2="630.88" y2="332.67"/>
        				<line class="st1" x1="959.88" y1="422" x2="630.88" y2="332.67"/>
        				<line class="st1" x1="959.88" y1="481" x2="630.88" y2="332.67"/>
        				<line class="st1" x1="630.88" y1="332.67" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="599" x2="630.88" y2="332.67"/>
        				<line class="st1" x1="959.88" y1="658" x2="630.88" y2="332.67"/>
        				<line class="st1" x1="959.88" y1="717" x2="630.88" y2="332.67"/>
        				<line class="st1" x1="959.88" y1="776" x2="630.88" y2="332.67"/>
        				<line class="st1" x1="959.88" y1="835" x2="630.88" y2="332.67"/>
        			</g>
        			<g>
        				<line class="st1" x1="1282.88" y1="451.17" x2="959.88" y2="245"/>
        				<line class="st1" x1="959.88" y1="304" x2="1282.88" y2="451.17"/>
        				<line class="st1" x1="959.88" y1="363" x2="1282.88" y2="451.17"/>
        				<line class="st1" x1="959.88" y1="422" x2="1282.88" y2="451.17"/>
        				<line class="st1" x1="959.88" y1="481" x2="1282.88" y2="451.17"/>
        				<line class="st1" x1="1282.88" y1="451.17" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="599" x2="1282.88" y2="451.17"/>
        				<line class="st1" x1="959.88" y1="658" x2="1282.88" y2="451.17"/>
        				<line class="st1" x1="959.88" y1="717" x2="1282.88" y2="451.17"/>
        				<line class="st1" x1="959.88" y1="776" x2="1282.88" y2="451.17"/>
        				<line class="st1" x1="959.88" y1="835" x2="1282.88" y2="451.17"/>
        			</g>
        			<g>
        				<line class="st1" x1="1282.88" y1="628.17" x2="959.88" y2="835"/>
        				<line class="st1" x1="959.88" y1="776" x2="1282.88" y2="628.17"/>
        				<line class="st1" x1="959.88" y1="717" x2="1282.88" y2="628.17"/>
        				<line class="st1" x1="959.88" y1="658" x2="1282.88" y2="628.17"/>
        				<line class="st1" x1="959.88" y1="599" x2="1282.88" y2="628.17"/>
        				<line class="st1" x1="1282.88" y1="628.17" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="481" x2="1282.88" y2="628.17"/>
        				<line class="st1" x1="959.88" y1="422" x2="1282.88" y2="628.17"/>
        				<line class="st1" x1="959.88" y1="363" x2="1282.88" y2="628.17"/>
        				<line class="st1" x1="959.88" y1="304" x2="1282.88" y2="628.17"/>
        				<line class="st1" x1="959.88" y1="245" x2="1282.88" y2="628.17"/>
        			</g>
        			<g>
        				<line class="st1" x1="1282.88" y1="569.17" x2="959.88" y2="835"/>
        				<line class="st1" x1="959.88" y1="776" x2="1282.88" y2="569.17"/>
        				<line class="st1" x1="959.88" y1="717" x2="1282.88" y2="569.17"/>
        				<line class="st1" x1="959.88" y1="658" x2="1282.88" y2="569.17"/>
        				<line class="st1" x1="959.88" y1="599" x2="1282.88" y2="569.17"/>
        				<line class="st1" x1="1282.88" y1="569.17" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="481" x2="1282.88" y2="569.17"/>
        				<line class="st1" x1="959.88" y1="422" x2="1282.88" y2="569.17"/>
        				<line class="st1" x1="959.88" y1="363" x2="1282.88" y2="569.17"/>
        				<line class="st1" x1="959.88" y1="304" x2="1282.88" y2="569.17"/>
        				<line class="st1" x1="959.88" y1="245" x2="1282.88" y2="569.17"/>
        			</g>
        			<g>
        				<line class="st1" x1="1282.88" y1="510.17" x2="959.88" y2="245"/>
        				<line class="st1" x1="959.88" y1="304" x2="1282.88" y2="510.17"/>
        				<line class="st1" x1="959.88" y1="363" x2="1282.88" y2="510.17"/>
        				<line class="st1" x1="959.88" y1="422" x2="1282.88" y2="510.17"/>
        				<line class="st1" x1="959.88" y1="481" x2="1282.88" y2="510.17"/>
        				<line class="st1" x1="1282.88" y1="510.17" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="599" x2="1282.88" y2="510.17"/>
        				<line class="st1" x1="959.88" y1="658" x2="1282.88" y2="510.17"/>
        				<line class="st1" x1="959.88" y1="717" x2="1282.88" y2="510.17"/>
        				<line class="st1" x1="959.88" y1="776" x2="1282.88" y2="510.17"/>
        				<line class="st1" x1="959.88" y1="835" x2="1282.88" y2="510.17"/>
        			</g>
        			<g>
        				<line class="st1" x1="630.88" y1="391.67" x2="959.88" y2="245"/>
        				<line class="st1" x1="959.88" y1="304" x2="630.88" y2="391.67"/>
        				<line class="st1" x1="959.88" y1="363" x2="630.88" y2="391.67"/>
        				<line class="st1" x1="959.88" y1="422" x2="630.88" y2="391.67"/>
        				<line class="st1" x1="959.88" y1="481" x2="630.88" y2="391.67"/>
        				<line class="st1" x1="630.88" y1="391.67" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="599" x2="630.88" y2="391.67"/>
        				<line class="st1" x1="959.88" y1="658" x2="630.88" y2="391.67"/>
        				<line class="st1" x1="959.88" y1="717" x2="630.88" y2="391.67"/>
        				<line class="st1" x1="959.88" y1="776" x2="630.88" y2="391.67"/>
        				<line class="st1" x1="959.88" y1="835" x2="630.88" y2="391.67"/>
        			</g>
        			<g>
        				<line class="st1" x1="630.88" y1="450.67" x2="959.88" y2="245"/>
        				<line class="st1" x1="959.88" y1="304" x2="630.88" y2="450.67"/>
        				<line class="st1" x1="959.88" y1="363" x2="630.88" y2="450.67"/>
        				<line class="st1" x1="959.88" y1="422" x2="630.88" y2="450.67"/>
        				<line class="st1" x1="959.88" y1="481" x2="630.88" y2="450.67"/>
        				<line class="st1" x1="630.88" y1="450.67" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="599" x2="630.88" y2="450.67"/>
        				<line class="st1" x1="959.88" y1="658" x2="630.88" y2="450.67"/>
        				<line class="st1" x1="959.88" y1="717" x2="630.88" y2="450.67"/>
        				<line class="st1" x1="959.88" y1="776" x2="630.88" y2="450.67"/>
        				<line class="st1" x1="959.88" y1="835" x2="630.88" y2="450.67"/>
        			</g>
        			<g>
        				<line class="st1" x1="633.88" y1="509.67" x2="959.88" y2="245"/>
        				<line class="st1" x1="959.88" y1="304" x2="633.88" y2="509.67"/>
        				<line class="st1" x1="959.88" y1="363" x2="633.88" y2="509.67"/>
        				<line class="st1" x1="959.88" y1="422" x2="633.88" y2="509.67"/>
        				<line class="st1" x1="959.88" y1="481" x2="633.88" y2="509.67"/>
        				<line class="st1" x1="633.88" y1="509.67" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="599" x2="633.88" y2="509.67"/>
        				<line class="st1" x1="959.88" y1="658" x2="633.88" y2="509.67"/>
        				<line class="st1" x1="959.88" y1="717" x2="633.88" y2="509.67"/>
        				<line class="st1" x1="959.88" y1="776" x2="633.88" y2="509.67"/>
        				<line class="st1" x1="959.88" y1="835" x2="633.88" y2="509.67"/>
        			</g>
        			<g>
        				<line class="st1" x1="630.88" y1="746.67" x2="959.88" y2="835"/>
        				<line class="st1" x1="959.88" y1="776" x2="630.88" y2="746.67"/>
        				<line class="st1" x1="959.88" y1="717" x2="630.88" y2="746.67"/>
        				<line class="st1" x1="959.88" y1="658" x2="630.88" y2="746.67"/>
        				<line class="st1" x1="959.88" y1="599" x2="630.88" y2="746.67"/>
        				<line class="st1" x1="630.88" y1="746.67" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="481" x2="630.88" y2="746.67"/>
        				<line class="st1" x1="959.88" y1="422" x2="630.88" y2="746.67"/>
        				<line class="st1" x1="959.88" y1="363" x2="630.88" y2="746.67"/>
        				<line class="st1" x1="959.88" y1="304" x2="630.88" y2="746.67"/>
        				<line class="st1" x1="959.88" y1="245" x2="630.88" y2="746.67"/>
        			</g>
        			<g>
        				<line class="st1" x1="630.88" y1="687.67" x2="959.88" y2="835"/>
        				<line class="st1" x1="959.88" y1="776" x2="630.88" y2="687.67"/>
        				<line class="st1" x1="959.88" y1="717" x2="630.88" y2="687.67"/>
        				<line class="st1" x1="959.88" y1="658" x2="630.88" y2="687.67"/>
        				<line class="st1" x1="959.88" y1="599" x2="630.88" y2="687.67"/>
        				<line class="st1" x1="630.88" y1="687.67" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="481" x2="630.88" y2="687.67"/>
        				<line class="st1" x1="959.88" y1="422" x2="630.88" y2="687.67"/>
        				<line class="st1" x1="959.88" y1="363" x2="630.88" y2="687.67"/>
        				<line class="st1" x1="959.88" y1="304" x2="630.88" y2="687.67"/>
        				<line class="st1" x1="959.88" y1="245" x2="630.88" y2="687.67"/>
        			</g>
        			<g>
        				<line class="st1" x1="630.88" y1="628.67" x2="959.88" y2="835"/>
        				<line class="st1" x1="959.88" y1="776" x2="630.88" y2="628.67"/>
        				<line class="st1" x1="959.88" y1="717" x2="630.88" y2="628.67"/>
        				<line class="st1" x1="959.88" y1="658" x2="630.88" y2="628.67"/>
        				<line class="st1" x1="959.88" y1="599" x2="630.88" y2="628.67"/>
        				<line class="st1" x1="630.88" y1="628.67" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="481" x2="630.88" y2="628.67"/>
        				<line class="st1" x1="959.88" y1="422" x2="630.88" y2="628.67"/>
        				<line class="st1" x1="959.88" y1="363" x2="630.88" y2="628.67"/>
        				<line class="st1" x1="959.88" y1="304" x2="630.88" y2="628.67"/>
        				<line class="st1" x1="959.88" y1="245" x2="630.88" y2="628.67"/>
        			</g>
        			<g>
        				<line class="st1" x1="633.88" y1="569.67" x2="959.88" y2="835"/>
        				<line class="st1" x1="959.88" y1="776" x2="633.88" y2="569.67"/>
        				<line class="st1" x1="959.88" y1="717" x2="633.88" y2="569.67"/>
        				<line class="st1" x1="959.88" y1="658" x2="633.88" y2="569.67"/>
        				<line class="st1" x1="959.88" y1="599" x2="633.88" y2="569.67"/>
        				<line class="st1" x1="633.88" y1="569.67" x2="959.88" y2="540"/>
        				<line class="st1" x1="959.88" y1="481" x2="633.88" y2="569.67"/>
        				<line class="st1" x1="959.88" y1="422" x2="633.88" y2="569.67"/>
        				<line class="st1" x1="959.88" y1="363" x2="633.88" y2="569.67"/>
        				<line class="st1" x1="959.88" y1="304" x2="633.88" y2="569.67"/>
        				<line class="st1" x1="959.88" y1="245" x2="633.88" y2="569.67"/>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="601.22" y1="333" x2="568.3" y2="333"/>
        				<g>
        					<polygon class="st4" points="608.28,333 598.33,328.93 600.69,333 598.33,337.06 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="601.22" y1="392" x2="568.3" y2="392"/>
        				<g>
        					<polygon class="st4" points="608.28,392 598.33,387.93 600.69,392 598.33,396.06 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="601.22" y1="451" x2="568.3" y2="451"/>
        				<g>
        					<polygon class="st4" points="608.28,451 598.33,446.93 600.69,451 598.33,455.06 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="601.22" y1="510" x2="568.3" y2="510"/>
        				<g>
        					<polygon class="st4" points="608.28,510 598.33,505.93 600.69,510 598.33,514.06 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="601.22" y1="569" x2="568.3" y2="569"/>
        				<g>
        					<polygon class="st4" points="608.28,569 598.33,564.93 600.69,569 598.33,573.06 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="601.22" y1="628" x2="568.3" y2="628"/>
        				<g>
        					<polygon class="st4" points="608.28,628 598.33,623.93 600.69,628 598.33,632.06 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="601.22" y1="687" x2="568.3" y2="687"/>
        				<g>
        					<polygon class="st4" points="608.28,687 598.33,682.93 600.69,687 598.33,691.06 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="601.22" y1="746" x2="568.3" y2="746"/>
        				<g>
        					<polygon class="st4" points="608.28,746 598.33,741.93 600.69,746 598.33,750.06 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<circle class="st5" cx="630.88" cy="333" r="17"/>
        			<circle class="st5" cx="630.88" cy="392" r="17"/>
        			<circle class="st5" cx="630.88" cy="451" r="17"/>
        			<circle class="st5" cx="630.88" cy="510" r="17"/>
        			<circle class="st5" cx="630.88" cy="569" r="17"/>
        			<circle class="st5" cx="630.88" cy="628" r="17"/>
        			<circle class="st5" cx="630.88" cy="687" r="17"/>
        			<circle class="st5" cx="630.88" cy="746" r="17"/>
        		</g>
        		<g>
        			<circle class="st5" cx="959.88" cy="244.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="303.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="362.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="421.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="480.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="539.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="598.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="657.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="716.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="775.83" r="17"/>
        			<circle class="st5" cx="959.88" cy="834.83" r="17"/>
        		</g>
        		<g>
        			<circle class="st5" cx="1282.88" cy="451" r="17"/>
        			<circle class="st5" cx="1282.88" cy="510" r="17"/>
        			<circle class="st5" cx="1282.88" cy="569" r="17"/>
        			<circle class="st5" cx="1282.88" cy="628" r="17"/>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="1305.15" y1="451.17" x2="1589.68" y2="451.17"/>
        				<g>
        					<polygon class="st4" points="1596.74,451.17 1586.79,455.23 1589.15,451.17 1586.79,447.1 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="1305.15" y1="510.25" x2="1589.68" y2="510.25"/>
        				<g>
        					<polygon class="st4" points="1596.74,510.25 1586.79,514.32 1589.15,510.25 1586.79,506.19 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="1305.15" y1="569.33" x2="1589.68" y2="569.33"/>
        				<g>
        					<polygon class="st4" points="1596.74,569.33 1586.79,573.4 1589.15,569.33 1586.79,565.27 					"/>
        				</g>
        			</g>
        		</g>
        		<g>
        			<g>
        				<line class="st3" x1="1305.15" y1="628.42" x2="1589.68" y2="628.42"/>
        				<g>
        					<polygon class="st4" points="1596.74,628.42 1586.79,632.48 1589.15,628.42 1586.79,624.35 					"/>
        				</g>
        			</g>
        		</g>
        	</g>
        </g>
        </svg>
      </div>
      <!-- <div class="intro">
        <div class="title">Défi n°1</div>
        <div class="text">Apprendre à Marcello les bases</div>
      </div> -->
      <div class="confidence">
        <ul>
          <li>Très incertain</li>
          <li>Peu confiant</li>
          <li>Incertain</li>
          <li>Confiant</li>
        </ul>
        <div class="needle" [style.transform]="'rotate('+(180*marcello.confidence)+'deg)'"></div>
      </div>
      <div class="categories">
        <ul>
          <li *ngFor="let cat of marcello.categories">
            <span class="label" [innerHTML]="cat.name"></span>
            <span class="progress" [style.width]="100*cat.p+'%'">
              <span class="label" [innerHTML]="cat.name"></span>
            </span>
          </li>
        </ul>
      </div>
      <div class="result" [style.backgroundColor]="'rgba(239, 64, 35, 1)'" *ngIf="marcello.best()">
        <div class="inner" [style.backgroundColor]="'rgba(255, 255, 255, '+0.5*(1-marcello.confidence)+')'" [innerHTML]="'Ceci est<br>'+marcello.best().desc+'&nbsp; !'" *ngIf="marcello.best()"></div>
      </div>
      <div class="feedback" *ngIf="marcello.best() != undefined">
        <div class="inner" *ngIf="!wrong">
          <div class="center">
            <!-- <div class="title">Feedback</div> -->
            <div class="instruction">C'est bien ça ?</div>
            <ul>
              <li><a (click)="onMatch(true)" [innerHTML]="'Oui'"></a></li>
              <li><a (click)="onMatch(false)" [innerHTML]="'Non'"></a></li>
            </ul>
          </div>
        </div>
        <div class="inner wrong" *ngIf="wrong">
          <div class="center">
            <br>
            <div class="instruction">Alors, de quoi s’agit-il ?</div>
            <ul>
              <li *ngFor="let cat of marcello.categories"><a (click)="onCategory(cat)" [innerHTML]="cat.name"></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="history">
        <ul>
          <li *ngFor="let img of history"><img [src]="img"></li>
        </ul>
      </div>
    </div>
    <div class="dessin">
      <canvas #canvas class="canvas"></canvas>
      <div class="instruction" *ngIf="virgin">Zone<br>de dessin</div>
      <a (click)="clean()" class="clean">&times;</a>
    </div>
    <div class="helpers">
      <div class="helper" *ngFor="let helper of datas?.helpers" [class.right]="helper.left > 1500" [class.bottom]="helper.top > 540" [style.left]="helper.left+'px'" [style.top]="helper.top+'px'">
        <a class="toggle" (click)="showHelper(helper)">?</a>
        <div class="more" *ngIf="helper == helperShown">
          <div class="title" [innerHTML]="helper.title"></div>
          <div class="description" [innerHTML]="helper.description"></div>
          <a (click)="hideHelper()" class="close">&times;</a>
        </div>
      </div>
    </div>

    <div class="marcella" [class.off]="!marcellaText || marcellaMuted">
      <div class="avatar">
        <div class="bubble">
          <div class="bubble_top"></div>
          <div class="bubble_center"></div>
          <div class="bubble_bottom"></div>
          <div class="table">
            <div class="cell">
              <div [innerHTML]="marcellaText"></div>
              <div class="btn"><a (click)="onOkMarcella()" [innerHTML]="'Ok'"></a></div>
            </div>
          </div>
        </div>
        <div (click)="onAllo()" class="allo" [innerHTML]="'Allo ?'"></div>
      </div>
    </div>

  </div>

  <a class="homeBtn" (click)="goHome()">
    <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
      <style type="text/css">
        .st0{fill:#FFFFFF;}
      </style>
      <path class="st0" d="M14,15c0.28,0,0.5-0.22,0.5-0.5v-7c0-0.13-0.05-0.26-0.15-0.35l-6-6c-0.2-0.2-0.51-0.2-0.71,0l0,0l-6,6
      C1.55,7.24,1.5,7.37,1.5,7.5v7C1.5,14.78,1.72,15,2,15H14z"/>
    </svg>
  </a>
  <div class="counter" *ngIf="counter > 0" [innerHTML]="counter"></div>
</div>
